import { ELocaleCode } from '@core/modules/intl/domain/enums';

export const venueViewActionsI18n = {
	[ELocaleCode.RU_RU]: {
		archive: 'Архивировать',
		unarchive: 'Разархивировать',
	},
	[ELocaleCode.EN_US]: {
		archive: 'Archive',
		unarchive: 'Unarchive',
	},
};
